import { render } from "./AdminOrgenIframe.vue?vue&type=template&id=1dc5d25c&ts=true"
import script from "./AdminOrgenIframe.ts?vue&type=script&lang=ts&external"
export * from "./AdminOrgenIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__